import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";
import AccountCircleOutlinedIcon from "@material-ui/icons/AccountCircleOutlined";
import MoreHorizOutlinedIcon from "@material-ui/icons/MoreHorizOutlined";
import SportsEsportsOutlinedIcon from "@mui/icons-material/SportsEsportsOutlined";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import PowerSettingsNewOutlinedIcon from "@mui/icons-material/PowerSettingsNewOutlined";
import { logout, LOGOUTAtive } from "../redux/slices/auth";
import { useDispatch, useSelector } from "react-redux";
import { setActive } from "../redux/slices/bottomtab";
import WalletIcon from "@mui/icons-material/Wallet";
import { FilterTiltShift } from "@mui/icons-material";

const Bottombar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const activeTab = useSelector((state) => state.tabs.activeTab);
  const [showMoreMenu, setShowMoreMenu] = useState(false);

  const handleLogout = () => {
    // dispatch(logout());
    dispatch(LOGOUTAtive(navigate));
    // navigate("/login");
  };
  const navItems = [
    {
      id: "wallet",
      path: "/wallet",
      icon: <WalletIcon />,
      label: "Wallet",
    },
    {
      id: "Cashout",
      path: "/cashout",
      icon: <MonetizationOnOutlinedIcon />,
      label: "Cashout",
    },
    {
      id: "Home",
      path: "/dashboard",
      icon: (
        <img className="w-[30px]" src="/images/homeicon.png" alt="home-icon" />
      ),
      label: "Home",
    },
    {
      id: "Profile",
      path: "/profile",
      icon: <AccountCircleOutlinedIcon />,
      label: "Profile",
    },
    {
      id: "More",
      icon: <MoreHorizOutlinedIcon />,
      label: "More",
      isButton: true,
      action: (dispatch) => {
        dispatch(setActive("More"));
        setShowMoreMenu((prev) => !prev);
      },
    },
  ];

  const moreMenuItems = [
    {
      path: "/dashboard",
      icon: <SportsEsportsOutlinedIcon />,
      label: "Games",
    },
    {
      path: "/history",
      icon: <HistoryOutlinedIcon />,
      label: "History",
    },
    {
      path: "/spin-a-wheel",
      icon: <FilterTiltShift />,
      label: "Spin a Wheel",
    },
    {
      label: "Logout",
      icon: <PowerSettingsNewOutlinedIcon />,
      isButton: true,
      action: handleLogout,
    },
  ];

  const handleLinkClick = (tab) => {
    dispatch(setActive(tab.id));
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-gradient-to-r from-[#3e0534] to-[#3e0433] text-white flex justify-around p-3 sm:hidden z-50 shadow-lg">
      {navItems.map((tab) =>
        tab.isButton ? (
          <button
            key={tab.id}
            className={`flex flex-col items-center w-[20%] ${
              activeTab === tab.id ? "text-yellow-400" : "text-[#c4b6c1]"
            }`}
            aria-label={tab.label}
            onClick={() => tab.action && tab.action(dispatch)}
          >
            {tab.icon}
            <span className="text-[10px]">{tab.label}</span>
          </button>
        ) : (
          <Link
            key={tab.id}
            to={tab.path}
            className={`flex flex-col items-center w-[20%] ${
              activeTab === tab.id ? "text-yellow-400" : "text-[#c4b6c1]"
            }`}
            aria-label={tab.label}
            onClick={() => handleLinkClick(tab)}
          >
            {tab.icon}
            <span className="text-[10px]">{tab.label}</span>
          </Link>
        )
      )}
      {showMoreMenu && (
        <div className="absolute bottom-full left-0 w-full bg-white text-black z-50 shadow-md">
          <div className="flex flex-col items-start divide-y divide-gray-300">
            {moreMenuItems.map((item, index) =>
              item.isButton ? (
                <button
                  key={index}
                  className="flex items-center text-black px-4 py-3 hover:text-gray-600 w-full"
                  onClick={() => {
                    item.action();
                    setShowMoreMenu(false);
                  }}
                >
                  {item.icon}
                  <span className="pl-2">{item.label}</span>
                </button>
              ) : (
                <Link
                  key={index}
                  to={item.path}
                  className="flex items-center text-black px-4 py-3 hover:text-gray-600 w-full"
                  onClick={() => setShowMoreMenu(false)}
                >
                  {item.icon}
                  <span className="pl-2">{item.label}</span>
                </Link>
              )
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Bottombar;
